export const HELP_CENTER_PATH = "/aide";
export const HELP_CENTER_CATEGORY_PATH = `${HELP_CENTER_PATH}/rubriques/:categoryId`;
export const HELP_CENTER_ARTICLE_PATH = `${HELP_CENTER_PATH}/articles/:articleId`;
export const HELP_CENTER_TICKETS_PATH = `${HELP_CENTER_PATH}/tickets`;

export const buildCategoryPath = (categoryId: string) =>
  HELP_CENTER_CATEGORY_PATH.replace(":categoryId", categoryId);

export const buildArticlePath = (articleId: string) =>
  HELP_CENTER_ARTICLE_PATH.replace(":articleId", articleId);
